import { useState, createContext, useMemo, useEffect } from 'react'
import { Form, Radio, message } from 'antd'
import service from '../../../@services'
import * as Utils from '../../../@utils'
import { procurementTypeFundStatus, procurementTypeEnum } from '../config'
import useProcurementTypeContext from './useProcurementTypeContext'

export const ProcurementType = createContext(procurementTypeEnum[0])

const PayStutusForm = ({ originForm, procurementType }) => {
  const isOrder = useMemo(
    () => procurementType === procurementTypeEnum[0],
    [procurementType]
  )
  return (
    <Form form={originForm} initialValues={{ fundStatus: isOrder ? 2 : 3 }}>
      <Form.Item
        label={isOrder ? '付款状态' : '退款状态'}
        name='fundStatus'
        required>
        <Radio.Group>
          {procurementTypeFundStatus[procurementType].map((item, index) => (
            <Radio key={index} value={item.value}>
              {item.key}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </Form>
  )
}

export default function useSelectColumsOperate({
  freshList = () => {},
  pageData,
  modal
}) {
  const { isOrder, procurementType, procurementTypeText } =
    useProcurementTypeContext()
  const [selectedRows, setSelectedRows] = useState([])
  const seletedIds = useMemo(
    () => selectedRows.map(item => item.id),
    [selectedRows]
  )
  const selectedRowKeys = useMemo(
    () => selectedRows.map(item => item.purchaseOrderNo),
    [selectedRows]
  )
  const serviceModule = isOrder ? service.purchaseOrder : service.purchaseReturn

  const exportList = async () => {
    if (checkSelected()) {
      let res = await serviceModule.export(
        selectedRows.map(item => item.purchaseOrderNo)
      )

      let fileName =
        procurementTypeText + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
      Utils.download(res, fileName)
    }
    // .then(data => {
    //   fileDownLoad(data, fileName)
    // })
  }
  const confirmBatchSetPayStatus = async res => {
    await serviceModule.markPayStatus({
      ids: seletedIds,
      ...res
    })
    freshList()
  }
  const [form] = Form.useForm()

  const openConfirmBatchSetPayStatusModal = () => {
    if (checkSelected())
      modal.confirm({
        content: (
          <PayStutusForm originForm={form} procurementType={procurementType} />
        ),
        onOk: () => {
          return confirmBatchSetPayStatus(form.getFieldsValue())
        }
      })
  }

  const checkSelected = () => {
    if (selectedRows.length <= 0) {
      message.info(`请选择${procurementTypeText}单`)
      return false
    }
    return true
  }
  const confirmDiscard = (ids = []) => {
    const _selectedIds = ids.length > 0 ? ids : seletedIds
    if (_selectedIds.length > 0) {
      modal.confirm({
        title: '提示',
        content: '确认是否作废当前单据，单据作废后库存将发生变动',
        onOk: () => {
          return serviceModule.billsDiscard(_selectedIds).then(() => {
            freshList()
          })
        }
      })
    } else {
      message.info(`请选择${procurementTypeText}单`)
    }
  }
  useEffect(() => {
    setSelectedRows([])
  }, [pageData])
  return {
    exportList,
    setSelectedRows,
    confirmDiscard,
    openConfirmBatchSetPayStatusModal,
    selectedRowKeys
  }
}
